console.log("theme.js loaded")

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';
import {cookiesEnabled} from '@shopify/theme-cart';

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

// Start Headersticky
//======================================================
// When the user scrolls the page, execute myFunction
window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementById("header");

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
// End Headersticky
//======================================================

$(document).ready(function() {
  $('nice-select').niceSelect();
});

$('.callouts').slick({
  arrows: false,
  dots: false,
  slidesToShow: 3,
  autoplay: false,
  responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },
  ]
});

$('.hero-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 2000
});

$( ".megamenu.megamenu-click  .megamenu-item-parent > a" ).click(function(e) {
  e.preventDefault();
  var id = $(this).data('id');
  $('.megamenu-nav-children[data-id!="'+id+'"]').removeClass('active');
  $('.megamenu-nav-children[data-id="'+id+'"]').addClass('active');
});

$( ".megamenu.megamenu-hover .megamenu-item-parent > a" ).hover(function(e) {
  e.preventDefault();
  var id = $(this).data('id');
  $('.megamenu-nav-children[data-id!="'+id+'"]').removeClass('active');
  $('.megamenu-nav-children[data-id="'+id+'"]').addClass('active');
  $(".megamenu-single-item").hover(function(e) {
    $('.megamenu-nav-children').removeClass('active');
  });
  $( ".header-main").mouseleave(function(e) {
    $('.megamenu-nav-children').removeClass('active');
  });
});

$( ".megamenu-nav-children").mouseleave(function(e) {
  $('.megamenu-nav-children').removeClass('active');
});

$( ".megamenu-nav-container").mouseleave(function(e) {
  $('.megamenu-nav-children').removeClass('active');
});


$(".dropdown-toggle").click(function(e) {
  e.preventDefault();
  $(this).closest(".dropdown").toggleClass("active");
  $(this).blur();
});

function setMainMinHeight(){
  var footerHeight = $('#shopify-section-footer').height()
  var headerHeight = $('#shopify-section-header').height()
  var calloutHeight = $('#shopify-section-callout').height()
  var minMainContentHeight = $(window).height() - footerHeight - headerHeight - calloutHeight;

  $('#MainContent').css("min-height", minMainContentHeight + "px")
}

$( window ).resize(function() {
  setMainMinHeight()
});

$( document ).ready(function() {
  setMainMinHeight()
});

$( document ).ready(function() {
  convertKrw();
});

function convertKrw() {
	var selectedCurrencyIso = localStorage.currencyIso;
    // alert(selectedCurrencyIso);
    if (selectedCurrencyIso == 'KRW') {
  	  $('.product-price-exc-vat').hide();
  	  $('.currency-picker option').removeAttr('selected');
  	  $.ajax({url: "https://api.exchangeratesapi.io/latest?symbols=KRW,GBP&base=GBP", success: function(result){
  	    // alert(result.rates.KRW);
  		var exchange = result.rates.KRW;
  		$(".money").each(function(){
  			// alert($(this).text());
  			var gbpPrice = $(this).text();
  			var gbpRawPrice = gbpPrice.replace(/[^\d.-]/g, '');
  			var convertedPrice = gbpRawPrice * exchange;
  			$(this).text( convertedPrice.toFixed(0) + '₩');
  		});
      }});
      $('.currency-picker').val('KRW');
      $('#currency-picker-wrapper').addCass('KRW');
    }
}

$('.productimg-link').click(function(){
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);
    return false;
});

// Ajax Cart Slideout
//======================================================
$('.cart-ajax .close-cart-drawer').click(function() {
  event.preventDefault();
  $('.cart-ajax').removeClass('cart-ajax--show');
  $('.ajax-cart-drawer__content').html('');
});


// Ajax Newsletter Modal Form
//======================================================
//Used for popup email form only for customer email sign up
//====================================================================
$('.newsletter-section #contact_form').submit(function(e) {
  event.preventDefault();
  var data = $(this).serialize();

 //create new account
  $.post('/contact', data)
    .done(function(data){
    var logErrors = $(data).find('.errors').text();
    console.log(data);

    //if there are errors show them in the html form
    if (logErrors.trim() != "" && logErrors.trim() != 'undefined'){
        $('.newsletteraccount-email-form .errors').html(logErrors);
        $('.newsletteraccount-email-form .errors').addClass('show');
    } else {
       $('.newsletter-section .errors').addClass('hide');
       $('.newsletter-section .toast-success').addClass('show');
       $('.form-elements').hide();
       $('.newsletter-subtitle').hide();
       $('.newsletter-title').hide();
    }
   }).fail(function(){console.log('error');});
   return false;

   $('.btn-clear').click(function() {
      $(this).closest('.modal').hide();
   });
});

// Ajax Search Header Button
//======================================================
$('.ajax-search-header').click(function() {
  event.preventDefault();
  $('.ajax-search-overlay').toggleClass('show');
  $('.header').toggleClass('bg-primary');
  $('.header').toggleClass('transparent');
  //$('.ajax-search-overlay .form-input').focus();
  //var input = $(".ajax-search-overlay .form-input");
  //input[0].selectionStart = input[0].selectionEnd = input.val().length;

});

$('.close-search-overlay').click(function() {
  event.preventDefault();
  $('.ajax-search-overlay').removeClass('show');
  //$('.ajax-search-overlay .form-input').blur();
});

// // Add class based on transparent header
// //=============================================================================
if($(".header").hasClass("transparent")) {
  $("body").addClass("transparent-header");
  $('.close-search-overlay').click(function() {
    event.preventDefault();
    $(".header-transparent").removeClass('bg-primary');
    $(".header-transparent").addClass('transparent');
	$("body").removeClass("transparent-header");
  });
}

// if($(".header-transparent").hasClass("transparent")) {
//   $("body").addClass("transparent-header");
//   $('.close-search-overlay').click(function() {
//     event.preventDefault();
//     $(".header-transparent").removeClass('bg-primary');
//     $(".header-transparent").addClass('transparent');
// 	$("body").removeClass("transparent-header");
//   });
// }

if($("body").hasClass("transparent-header")) {
  $('.megamenu .megamenu-item-parent').on({
    mouseenter: function() {
      $('.header').addClass('bg-primary');
      $(".header").removeClass('transparent');
    }
  });
  $('.megamenu').on({
    mouseleave: function() {
      $('.header').removeClass('bg-primary');
      $(".header").addClass('transparent');
    }
  });
}

// Tab content
//======================================================
$(".tab-content-1").fadeIn();
$(".tab-item-1").addClass('active');

$( ".tab-item a" ).click(function(e) {
  e.preventDefault();
  $(".tab-item").removeClass('active');
  $(this).parent('.tab-item').addClass('active');
  var id = $(this).data('id');
  $('.tab-content[data-id!="'+id+'"]').fadeOut();
  $('.tab-content[data-id!="'+id+'"]').hide();
  $('.tab-content[data-id="'+id+'"]').fadeIn();
  $('.tab-content[data-id="'+id+'"]').show();
});
//======================================================

$( "a.reveal-text").click(function(e) {
  e.preventDefault();
  $('.trim-text').removeClass('active');
  $('.full-text').addClass('active');
});

$( "a.hide-text").click(function(e) {
  e.preventDefault();
  $('.full-text').removeClass('active');
  $('.trim-text').addClass('active');
});

// Currencies
//======================================================
// $(function() {
//   $('.currency-picker').selectric();
//
//   var currency = $(".selectric-currency-picker .selectric-items li.selected").text()
//   $(".selectric-currency-picker .label").addClass('currency-' + currency.toLowerCase());
//
//   $('.selectric-currency-picker').change(function(){
//     var currency = $(".selectric-currency-picker .selectric-items li.selected").text()
//
//     $(".selectric-currency-picker span").removeClass();
//     $(".selectric-currency-picker span").addClass('label');
//     $(".selectric-currency-picker span").addClass('currency-' + currency.toLowerCase());
//
//     if(currency != 'GBP' || currency != 'EUR') {
//       $('.exc-vat-label').hide();
//       $('.product-price-inc-vat').hide();
//       $('.product-price-exc-vat.product-price-exc-vat-styles').removeClass('product-price-exc-vat-styles');
//       $('.product-card-hide-excvat .product-price-exc-vat').show();
//     }
//
//     if(currency == 'GBP' || currency == 'EUR') {
//       $('.exc-vat-label').show();
//       $('.product-price-inc-vat').show();
//       $('.product-price-exc-vat').addClass('product-price-exc-vat-styles');
//       $('.product-card-hide-excvat .product-price-exc-vat').hide();
//     }
//   });
// });

/*$(function() {
  $('.currency-picker').selectric();

  var currency = $(".selectric-currency-picker .selectric-items li.selected").text()
  $(".selectric-currency-picker .label").addClass('currency-' + currency.toLowerCase());

  $("body").addClass("currency-" + currency);

  $('.selectric-currency-picker').change(function(){
    var currency = $(".selectric-currency-picker .selectric-items li.selected").text();

    $(".selectric-currency-picker span").addClass('currency-' + currency.toLowerCase());
  });
});
*/

//get select currency and add value to as class
if (localStorage.currencyIso == 'KRW') {
  $('#currency-picker-wrapper').attr('class', '').addClass('KRW');
  $('body').addClass('currency-KRW');
} else {
  $('#currency-picker-wrapper').attr('class', '').addClass($('.shopify-currency-form select').children(':selected').val());
  $('body').addClass('currency-'+$('.shopify-currency-form select').children(':selected').val());
}

if (localStorage.currencyIso != 'GBP' && localStorage.currencyIso != 'EUR') {
  $('.cart-subtotal-vat-inc').hide();
}

$('.shopify-currency-form select').on('change', function() {
  // $('#currency-picker-wrapper').attr('class', '').addClass($(this).children(':selected').val());
  // alert($(this).find(":selected").text());
  localStorage.currencyIso = $(this).find(':selected').text();
  if ($(this).find(':selected').text() == 'KRW') {
	  $(this).val('GBP');
  }
  $(this)
    .parents('form')
    .submit();
});

//Resize Collection select on change
$(document).ready(function() {
  $("#widthTempOption").html($('#sort-by option:selected').text());
  $('#sort-by').width($("#selectTagWidth").width());
 $('#sort-by').change(function(){
    $("#widthTempOption").html($('#sort-by option:selected').text());
    $('#sort-by').width($("#selectTagWidth").width());
 });
});

$(".close-gallery").on("click", function(e) {
  e.preventDefault;
  $(this).closest('.modal-gallery').removeClass('active');
});

$(".show-gallery").on("click", function(e) {
  e.preventDefault;
  $('.modal-gallery').addClass('active');
});

$(".secondary-accordion").click(function(e) {
  e.preventDefault();
  $(this).addClass("active");
  $(this).siblings(".secondary-accordion-body").toggleClass("active");
  $(this).siblings(".icon").removeClass("icon-right");
  $(this).siblings(".icon").addClass("icon-down");
  $(this).blur();
});

$(".secondary-accordion.active").click(function(e) {
  e.preventDefault();
  $(this).siblings(".secondary-accordion-body").removeClass("active");
});
